import { render, staticRenderFns } from "./dialog-audit-task.vue?vue&type=template&id=390c06de&"
import script from "./dialog-audit-task.vue?vue&type=script&lang=js&"
export * from "./dialog-audit-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports